<template>
  <div class="page-subheader" style="width:100%;">
    <div-container class="has-text-centered" padding-top="0rem" padding-bottom="0rem">
      <div class="columns is-gapless is-centered is-flex-mobile is-vcentered">
        <div class="column is-11 wrapper" :class="[{ 'has-text-left': !textAlign || textAlign === 'left', 'has-text-centered': textAlign === 'center', 'has-text-right': textAlign === 'right' }]">
        <h1 :style="titleStyle">{{ title }}</h1>
      </div>
    </div>
    </div-container>
  </div>
</template>

<script>
import DivContainer from '@/components/DivContainer'
export default {
  name: 'page-subheader',
  props: ['title', 'text-align', 'title-style'],
  components: {
    DivContainer
  },
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
    refresh: function () {
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// page-header

.page-subheader {
  width: 100%;

  .columns.is-gapless > .column {
    &.wrapper {
      padding-top: 1rem;
      padding-bottom: 1rem;
      // background-color: white;

      // these shall tally with div-columns
      padding-left: 15px;
      padding-right: 15px;
      @media screen and (min-width: $tablet) {
        padding-left: 15px;
        padding-right: 15px;
      }
      // padding-left: 1.5em;
      // padding-right: 1.5em;
      // @media screen and (min-width: $tablet) {
      //   padding-left: 3em;
      //   padding-right: 3em;
      // }
    }

    h1, h2, h3, h4, h5, h6 {
      padding-top: 0rem;
      padding-bottom: 0rem;
      color: $color-darkbrown;
      // font-size: 2.5rem;
      font-family: $font-family-title;
      text-transform: uppercase;
      // border-bottom: 5px dashed $color-beige;
      border-bottom: 3px solid $color-darkbrown;
      display: inline-block;
    }
  }
}

</style>



// WEBPACK FOOTER //
// PageSubheader.vue?a7d29a90